

















import { Component, Mixins } from "vue-property-decorator";
import CheckoutForm from "@/components/checkout/CheckoutForm.vue";
import OrderSummary from "@/components/checkout/OrderSummary.vue";
import CheckoutFooter from "@/components/footer/CheckoutFooter.vue";
import { Mobile } from "@/mixins/mobile";
import { namespace } from "vuex-class";
import { StoreModule } from "@/store/types";
import { OrderGetters } from "@/store/modules/order/types";
import { LineItem } from "@/models/order/order";
@Component({
  components: {
    CheckoutForm,
    OrderSummary,
    CheckoutFooter
  }
})
export default class Checkout extends Mixins(Mobile) {
  @(namespace(StoreModule.Order).Getter(OrderGetters.GetOrderItems))
  items!: LineItem[];

  created() {
    if (!this.items || this.items.length < 1) {
      this.$router.replace("/cart");
    }
  }
}
